<script>
  export let id;
  export let value;
  export let current;
  export let label = "";
  export let required = false;
</script>

<div class="form-group input-checkbox check-left" class:in={current === id} class:filled={value}>
  <!-- <input type="hidden" name={id} value="" /> -->
  <input type="checkbox" name={id} bind:checked={value} {required} />
  <span class="check" />
  <label for={id}>
    <slot class="label">{label}</slot>
  </label>
</div>

<style>
  .form-group.input-checkbox {
    position: relative;
    background-color: transparent;
    height: 18px;
  }

  .input-checkbox [type="checkbox"] {
    cursor: pointer;
    height: 17px;
    left: 0;
    margin: 0 !important;
    opacity: 0;
    position: absolute;
    top: 2px;
    width: 17px;
  }

  .input-checkbox [type="checkbox"]:not(:checked) + .check::before {
    background: #fff;
    border: 1px solid #ccc;
  }
  .input-checkbox [type="checkbox"]:checked + .check::before {
    background: var(--primary-light-color);
  }

  .input-checkbox .check::before {
    border-radius: 2px;
    content: "";
    height: 17px;
    left: 0;
    position: absolute;
    top: 0;
    width: 17px;
  }

  .input-checkbox [type="checkbox"]:not(:checked) + .check::after {
    opacity: 0;
  }
  .input-checkbox [type="checkbox"]:checked + .check::after {
    opacity: 1;
  }

  .input-checkbox .check::after {
    color: #fff;
    content: "\2713";
    font-size: 13px;
    height: 17px;
    left: 0;
    line-height: 16px;
    position: absolute;
    top: 0;
    -webkit-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    width: 17px;
  }

  .input-checkbox label {
    line-height: 1.3;
    margin-bottom: 0;
    font-size: 14px;
  }

  .input-checkbox.check-left label {
    padding-left: 25px;
  }
  .input-checkbox .check {
    cursor: pointer;
    display: inline-block;
    height: 17px;
    left: 0;
    pointer-events: none;
    position: absolute;
    text-align: center;
    top: 2px;
    width: 17px;
  }
</style>
